<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top fixed-judul">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                    <img src="../../assets/img/x2.svg" alt="" data-toggle="modal" data-target="#modal">
                </div>
                <div class="col-md-6 col-sm-6 col-6 text-center remove-padding" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                    Tambah Karyawan</div>
                <div class="col-md-3 col-sm-3 col-3 remove-padding">
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <div class="animasi-card  bg-transparent d-flex mar-bottom-16">
                        <div class="font-16 status-login" style="padding: 2px 10px;color: #206CFF">Langkah <span class="font-weight-bold">{{isWebview() ? '1/3' : '1/4'}}</span></div>
                    </div>
                    <div class="text-createstaff mar-bottom-16 color-0000 line-height-25 letter-space-002">
                        Silahkan isi data karyawan anda.
                    </div>
                    <form action="">
                        <div class="form-group">
                            <div>
                                <label class="remove-margin require font-14 color-6f7" for="namakaryawan">Nama Karyawan</label>
                                <input type="text" class="form-control inputs font-16" id="namakaryawan"
                                       aria-describedby="emailHelp" placeholder="EX:Harmania" v-on:keyup="handlingname" v-model="datacreatestaff.nama_karyawan">
	                            <ErrorMessage class="error" label="Nama Karyawan" :validation="$v.datacreatestaff.nama_karyawan"></ErrorMessage>
                            </div>
                            <div class="mar-top-12">
                                <label class="remove-margin require font-14 color-6f7" for="phone">Nomor Whatsapp</label>
                                <div class="input-group remove-padding">
                                    <vue-country-code
                                        @onSelect="onSelect" :preferredCountries="['id', 'my', 'bn']">
                                    </vue-country-code>
                                    <input type="tel" class="form-control inputs font-16" id="phone" placeholder="87171230419" v-on:keyup="onlynumber" v-model="datacreatestaff.telp_karyawan">
                                </div>
	                            <ErrorMessage class="error" label="Nomor Whatsapp" :validation="$v.datacreatestaff.telp_karyawan"></ErrorMessage>
	                            <span class="f-12 f-c-midgrey m-t-4">
	                                    Pastikan nomor karyawan benar, nomor digunakan untuk verifikasi ketika karyawan lupa password.
                                    </span>
                            </div>
                            <div>
                                <label class="remove-margin mar-top-12 require font-14 color-6f7" for="alamat">Alamat</label>
                                <textarea type="text" class="form-control inputs font-16" id="alamat" aria-describedby="emailHelp"
                                          placeholder="Jln. Jendral Bersih Selalu No. 1" v-on:keyup="handlingalamat" v-model="datacreatestaff.alamat_karyawan"></textarea>
	                            <ErrorMessage class="error" label="Alamat" :validation="$v.datacreatestaff.alamat_karyawan"></ErrorMessage>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut ">
                    <button class="btn btn-login btn-long remove-margin" id="btnpersonal" @click="cekname">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span><span id="textBtnpersonal">Berikutnya</span>
                    </button>
                </div>
            </div>
            <div class="modal fade" id="modal" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Batalkan Menambah Karyawan</h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <p class="m-0 black-90">Apakah anda yakin ingin membatalkan pembuatan data Karyawan baru? </p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                    @click="back()">Ya, Batalkan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modal-lewati-panduan-karyawan" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content w-limit">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Batal Mengikuti Panduan</h5>
                            <div class="nav-btn kanan tutup">
                            </div>
                        </div>
                        <div class="modal-body">
                            <p>Anda sedang mengikuti panduan pengguna, batal mengikuti panduan akan menghentikan mode
                                panduan. Apakah Anda yakin ingin keluar dari panduan?</p>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-long m-d-20"
                                    @click="closeModal"
                                    data-dismiss="modal">
                                Lanjutkan Panduan
                            </button>
                            <a @click="skipOnboarding(3)" class="m-t-20 f-semi f-12 f-c-blue">Saya Ingin Keluar
                                Dari
                                Mode Panduan</a>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, maxLength, required} from "vuelidate/lib/validators";

    export default {
        name: "CreateStaff",
        data(){
            return{
                telpCode: '',
                isClicked:false,
            }
        },
	    components: { ErrorMessage },
	    validations: {
		    datacreatestaff: {
		    	nama_karyawan: {
		    		required,
				    minLength: minLength(2)
			    },
			    telp_karyawan: {
		    		required,
				    minLength: minLength(8),
				    maxLength: maxLength(12),
			    },
			    alamat_karyawan: {
		    		required,
				    minLength: minLength(2),
			    },
          telp_code: {
            required
          }
		    }
	    },
        props: ["datacreatestaff"],
        mounted(){
            this.cekvalidasi()
        },
        methods:{
            back(){
                this.$emit("showkaryawanlist")
            },
            onSelect({name, iso2, dialCode}) {
              this.telpCode=dialCode;
              this.datacreatestaff.telp_code= dialCode;
            },
            async skipOnboarding(params) {
                if (localStorage.getItem("step_walkthrough") !== undefined && localStorage.getItem("step_walkthrough") === "2"){
                    try {
                        const datawalkthrough = new FormData
                        datawalkthrough.append('walkthrough', params)
                        const response = await this.$axios.post(this.$baseurl + '/masterData/owner/update_status_walkthrough', datawalkthrough,{
                            headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                            }
                        });
                        if (response.data.code === 200) {
                            if (response.data.status === true) {
                                localStorage.setItem("step_walkthrough", params)
                                this.back()
                            }
                        } else {
                            this.$toast.error(response.data.msg)
                        }
                    } catch (e) {
                        this.$catch_error_response(e)
                    }
                }
            },
            closeModal(){
                $("#modal-lewati-panduan-karyawan").modal("hide")
            },
            async cekname(){
            	if (this.$v.datacreatestaff.$invalid) {
		            this.$v.datacreatestaff.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
		            return
	            }
                this.isClicked = true
                $('#textBtnpersonal').hide()
                $('#btnpersonal').prop('disabled', true);
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/karyawan/cek_nama_karyawan?nama='+ this.datacreatestaff.nama_karyawan, this.datacreatestaff.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.$emit("showdataakun")
                            this.isClicked = false
                            $('#textBtnpersonal').show()
                            $('#btnpersonal').prop('disabled', false);
                        }else{
                            this.$toast.error(response.data.msg)
                            this.isClicked = false
                            $('#textBtnpersonal').show()
                            $('#btnpersonal').prop('disabled', false);
                        }
                    }
                }catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked = false
                    $('#textBtnpersonal').show()
                    $('#btnpersonal').prop('disabled', false);
                }
            },
            Next(){
                this.$emit("showdataakun")
            },
            onlynumber(event){
                var phoneField = event.target.value;
                var frstCar = phoneField.substring(0, 1);
                var firstTel = phoneField.substring(1, 13);
                var secCar = phoneField.substring(0, 2);
                var secTel = phoneField.substring(2, 13);
                var thrdcar = phoneField.substring(0, 12);
                var output


                if (frstCar == 0) {
                    output = firstTel
                } else if (secCar == this.telpCode) {
                    output = secTel
                } else {
                    output = thrdcar
                }
                var number = output.replace(/[^0-9]+/, '');

                var charLenght = number.length;
                if (charLenght >= 8 && charLenght <= 12) {
                    $('#btnpersonal').prop('disabled', false);
                } else {
                    $('#btnpersonal').prop('disabled', true);
                }
                this.datacreatestaff.telp_karyawan = number;
                this.cekvalidasi()
            },

            handlingname(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z .,'-]+/,'');
                this.datacreatestaff.nama_karyawan = number
                this.cekvalidasi()
            },

            handlingalamat(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z .,'-]+/,'');
                this.datacreatestaff.alamat_karyawan = number
                this.cekvalidasi()
            },

            cekvalidasi(){
                return
                var staffname = this.datacreatestaff.nama_karyawan;
                var stafftelp = this.datacreatestaff.telp_karyawan;
                var staffaddres = this.datacreatestaff.alamat_karyawan;
                var stringstafftelp = stafftelp.toString()
                var lenPass = staffname.length;
                if (lenPass >= 2 && (stringstafftelp.length >= 8 && stringstafftelp.length <= 12) && staffaddres.length >= 2) {
                    $('#btnpersonal').prop('disabled', false);
                } else {
                    $('#btnpersonal').prop('disabled', true);
                }
            }
        }
    }
</script>

<style scoped>
    .text-createstaff{
        line-height: 21px;
        align-items: center;
        letter-spacing: -0.01em;
    }
</style>